import React from "react";
import { TextArea, type TextAreaProps } from "semantic-ui-react";

interface Props extends TextAreaProps {
  errorMessage?: string
}

const TextAreaWithError = (props: Props) => {
  const { errorMessage, ...rest } = props;

  const hasErrorMessage = !!errorMessage;

  return <>
    <TextArea error={hasErrorMessage || rest.error} {...rest} />

    {hasErrorMessage && <div className="s1_warning">
      {errorMessage}
    </div>}
  </>;
};

export default TextAreaWithError;
